import React from 'react'

function CursorIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={27}
      height={25.9}
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M16.598 11.35v-.75a1.25 1.25 0 1 1 2.5 0v3.939a6.061 6.061 0 0 1-6.061 6.06h-.284c-3.411 0-5.118-2.818-6.383-5.766-.601-1.402-.816-2.762.528-3.483l2.2-1v3.5"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M14.098 11.35V9.6a1.25 1.25 0 1 1 2.5 0v1.75"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M11.598 11.35v-2a1.25 1.25 0 1 1 2.5 0v.75M9.098 13.85V4.6a1.25 1.25 0 0 1 2.5 0v5.75"
      />
    </svg>
  )
}
export default CursorIcon
